module.exports = __webpack_public_path__ + "images/pages/injection-guidelines/transoral-step-5.png";